// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"M_wB f_hL f_dp f_ds f_dD f_cH f_c4","menuItemSub":"M_wC f_cP f_dp f_dD","menuMainLink":"M_wD f_hM f_gp","menuLink":"M_wF f_hM f_gp","Link":"M_bD d_bD d_V d_bd"};